<template>
  <div class="game-n-page page">
    <div class="content-card">
      <div class="section">
        <div class="section-label">{{ $t("gameN.style") }}</div>
        <div class="section-content">
          <div class="tags">
            <span
              v-for="item in styleOptions"
              :key="item.key"
              :class="['tag', { active: selectedStyle === item.key }]"
              @click="selectedStyle = item.key"
            >
              {{ item.label }}
            </span>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-label">{{ $t("gameN.want") }}</div>
        <div class="section-content">
          <div class="tags">
            <span
              v-for="item in wantOptions"
              :key="item.key"
              :class="['tag', { active: selectedWant === item.key }]"
              @click="selectedWant = item.key"
            >
              {{ item.label }}
            </span>
          </div>
        </div>
      </div>

      <button class="start-btn" @click="startJourney">
        {{ $t("gameN.start_journey") }}
      </button>
    </div>
  </div>
</template>

<script>
const styleOptionKeys = [
  "internet_celebrity",
  "moderator",
  "model",
  "nurse",
  "secretary",
  "married_woman",
  "student",
  "pregnant_woman",
  "mother_and_daughter",
  "lolita",
];

const wantOptionKeys = ["trio", "arm_relationship", "spray", "sm"];

export default {
  name: "GameN",
  data() {
    return {
      selectedStyle: "internet_celebrity",
      selectedWant: "trio",
    };
  },
  computed: {
    styleOptions() {
      return styleOptionKeys.map((key) => ({
        key,
        label: this.$t(`gameN.styles.${key}`),
      }));
    },
    wantOptions() {
      return wantOptionKeys.map((key) => ({
        key,
        label: this.$t(`gameN.wants.${key}`),
      }));
    },
  },
  methods: {
    startJourney() {
      this.$router.push({
        path: "/Lottery",
        query: {
          key: "game1",
          id: 10,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.game-n-page {
  min-height: 100%;
  padding: 328px 24px 160px;
  background: url(/img/gamen/game1.jpg) no-repeat center top / cover;
  box-sizing: border-box;
}

.content-card {
  width: 100%;
  height: 560px;
  padding: 40px 30px 34px;
  background: #fff;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.section + .section {
  margin-top: 28px;
}

.section {
  display: flex;
  align-items: flex-start;
}

.section-label {
  width: 82px;
  flex-shrink: 0;
  padding-top: 6px;
  color: #6c5e5d;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
}

.section-content {
  flex: 1;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 18px;
}

.tag {
  padding: 8px 18px;
  border-radius: 22px;
  color: #5f5f60;
  font-size: 21px;
  line-height: 32px;
  background: transparent;
}

.tag.active {
  color: #fff;
  background: linear-gradient(90deg, #a78ef8 0%, #8383ee 100%);
}

.start-btn {
  width: 100%;
  height: 66px;
  margin-top: 36px;
  border: none;
  border-radius: 33px;
  background: linear-gradient(90deg, #6667e8 0%, #5a63de 100%);
  color: #fff;
  font-size: 26px;
  line-height: 66px;
  font-weight: 500;
}
</style>
